import * as React from 'react'
import { InspectionsContext } from './Context'

export const useInspectionsContext = () => React.useContext(InspectionsContext)
